<script lang="ts">
  import Accordion from "$components/common/Accordion.svelte";
  import { t } from "$lib/i18n/translations";
  const questionList = [
    {
      question: "general.question.question1.question",
      answer: "general.question.question1.answer",
    },
    {
      question: "general.question.question2.question",
      answer: "general.question.question2.answer",
    },
    {
      question: "general.question.question3.question",
      answer: "general.question.question3.answer",
    },
    {
      question: "general.question.question4.question",
      answer: "general.question.question4.answer",
    },
    {
      question: "general.question.question5.question",
      answer: "general.question.question5.answer",
    },
    // {
    //   question: "general.question.question6.question",
    //   answer: "general.question.question6.answer",
    // },
    {
      question: "general.question.question7.question",
      answer: "general.question.question7.answer",
    },
    {
      question: "general.question.question8.question",
      answer: "general.question.question8.answer",
    },
  ];
</script>

<!-- QA -->
<section class="w-full bg-[#EAF0FD]">
  <div
    class="max-w-[1312px] mx-auto w-full w-full flex flex-col items-center justify-center px-[16px]"
  >
    <div
      class="mt-[100px] mb-[50px] text-center max-w-[1000px] max-mobile:mt-[60px] max-mobile:mb-[24px]"
    >
      <h2
        class="!text-[36px] !font-bold !leading-normal !mb-4 max-mobile:!text-[20px]"
      >
        {$t("general.question.title")}
      </h2>
    </div>
    <div class="mb-[66px] max-mobile:mb-0">
      {#each questionList as question}
        <Accordion
          title={$t(question.question)}
          content={$t(question.answer)}
        />
      {/each}
    </div>
  </div>
</section>
